import React from 'react';

function Blockbc({ language }) {
  // Content for both English and Hindi
  const content = {
    en: [
      {
        title: "The Pandav's Trial of Exile",
        image: "images/main-attractions/block-bc/block-bc-1.png",
        description: `The Pandavs spent twelve years in arduous exile and one year in incognito, during which they understood the importance of humility, patience, and the transience of worldly life. These experiences strengthened them mentally and spiritually, preparing them for the reclamation of their kingdom and the great war of Kurukshetr.`,
        label: "Main Attraction",
      },
      {
        title: "Krishna’s Final Warning",
        image: "images/main-attractions/block-bc/block-bc-2.png",
        description: `After years of exile and disguise, the Pandavs longed for their rightful throne, but Duryodhan refused to yield. In a final plea for peace, Lord Krishna asked only for five  villages, yet Duryodhan spurned the offer. Then Krishna revealed his cosmic form, declaring that war was now certain. His vast form embodied the universe itself—past, present and future within. Thus, war remained the final fate to embrace.`,
        label: "Main Attraction",
      },
      {
        title: "The Epic Battle",
        image: "images/main-attractions/block-bc/block-bc-3.png",
        description: `The Mahabharat’s great war is depicted from its beginning to the final climactic moments, highlighting the bravery of iconic warriors like Bhishm, Dronacharya, Karn, and Abhimanyu. It includes the intense mace battle between Duryodhan and Bhim, capturing the eternal conflict between dharm and adharm. The narrative brings forth the deep emotions of the characters and the fierce intensity of this historic battle.`,
        label: "Main Attraction",
      },
      {
        title: "Great Warriors of the Mahabharat (Pandavs)",
        image: "images/main-attractions/block-bc/block-bc-6.png",
        description: `Here stand not just the images of great warriors, but the living echoes of their courage, honor, and values`,
      },
      {
        title: "Great Warriors of the Mahabharat (Kauravs)",
        image: "images/main-attractions/block-bc/block-bc-4.png",
        description: `Step into the realm of those who stood for adharma in the great battle of Kurukshetra,`,
      },
      
      
      // Add other items here...
    ],
    hi: [
      {
        title: "पांडवों का वनवास",
        image: "images/main-attractions/block-bc/block-bc-1.png",
        description: `पांडवों ने बारह वर्ष कठिन वनवास और एक वर्ष अज्ञातवास में बिताए, जहाँ उन्होंने विनम्रता, धैर्य और सांसारिक जीवन की क्षणभंगुरता को समझा। इन अनुभवों ने उन्हें मानसिक और आध्यात्मिक रूप से मज़बूत किया, जिससे वे अपने राज्य की पुनः प्राप्ति और कुरुक्षेत्र के युद्ध के लिए तैयार हुए।`,        
        label: "मुख्य आकर्षण",
      },
      {
        title: "कृष्ण की चेतावनी",
        image: "images/main-attractions/block-bc/block-bc-2.png",
        description: `वनवास और अज्ञातवास के बाद, पांडव अपने अधिकारों की वापसी चाहते थे, लेकिन दुर्योधन को यह स्वीकार नहीं था। शाति की आखिरी कोशिश में भगवान कृष्ण ने पाँच ग्रामों का प्रस्ताव रखा, जिसे दुर्योधन ने ठुकरा दिया। तब कृष्ण ने अपना  विराट रूप धारण कर चेतावनी दी कि अब युद्ध अवश्यंभावी है। यह स्वरूप समस्त ब्रह्मांड का प्रतीक था, जिसमें अतीत, वर्तमान और भविष्य समाहित थे। अब केवल युद्ध ही अंतिम विकल्प बचा था।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "महासंग्राम",
        image: "images/main-attractions/block-bc/block-bc-3.png",
        description: `महाभारत का महासंग्राम युद्ध के आरंभ से लेकर अंतिम निर्णायक क्षणों तक की गाथा प्रस्तुत करती है। इसमें भीष्म, द्रोणाचार्य, कर्ण, अभिमन्यु जैसे प्रमुख योद्धाओं के साहसिक संघर्ष, और दुर्योधन तथा भीम के बीच गदा युद्ध का उल्लेख है। यह कथा धर्म और अधर्म के बीच जारी महान संग्राम की नाटकीयता, पात्रों की भावनाएं और युद्ध की भयंकरता को प्रभावशाली रूप से दर्शाती है।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "महाभारत के महारथी (कौरव) ",
        image: "images/main-attractions/block-bc/block-bc-6.png",
        description: `अब आप उस स्थान पर हैं जहाँ वे पात्र उपस्थित हैं जिन्होंने कुरुक्षेत्र में अधर्म का साथ दिया.`,
      },
      { 
        title: "महाभारत के महारथी (पांडव)",
        image: "images/main-attractions/block-bc/block-bc-4.png",
        description: `ये वह स्थान है जहाँ महान योद्धाओं की सिर्फ़ छवियाँ ही नहीं दिखाई देती बल्कि उनके जीवन मूल्यों की प्रतिध्वनियाँ भी सुनाई देती हैं।`,
      },
      // Add other items here...
    ],
  };

  return (
    <div className="main_attractions_list">
      {content[language].map((item, index) => (
        <div className="list_item" id={`ma-blockbc-${index}`} key={index}>
          <div className="attraction_image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="attranction_details">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            {item.label && <span className="main-attraction-label">{item.label}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Blockbc;
